module.exports = __webpack_public_path__ + "static/img/9.3fb7a71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/9.png
// module id = QXqg
// module chunks = 0